/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down': {
    width: 43,
    height: 43,
    viewBox: '0 0 43 43',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M23.383 25.63a3 3 0 01-4.366 0l-7.969-8.455a1 1 0 011.456-1.372l7.968 8.456a1 1 0 001.456 0l7.968-8.456a1 1 0 011.456 1.372l-7.969 8.456z" _fill="#000"/>'
  }
})
